export const personalInfo = {
  firstName: "Hridoy",
  lastName: "Hossain",
  fullName: "Hridoy Hossain",
  initials: "HH",
  role: "Senior Consultant",
  bio: "Results-driven Senior Consultant specializing in strategic planning, process optimization, and organizational leadership. With a proven track record of guiding cross-functional teams, I transform complex business challenges into actionable growth opportunities—empowering clients to achieve operational excellence and sustainable success.",
  availability: "Open to opportunities",
  location: "1340 Savar, Dhaka, Bangladesh",
  email: "hridoyhossain341@gmail.com",
  phone: "+8801318-712537",
  avatar: "/assets/profile/avatar.jpg",
  github: "https://github.com/shahedmun12-dotcom",
  linkedin: "https://linkedin.com/in/md-hridoy-6b5412278",
  facebook: "https://facebook.com/shahedmuntasir",
  whatsapp: "https://wa.me/8801318712537",
};

export const stats = [
  { value: "BBA", label: "Department" },
  { value: "PRO", label: "MS Office" },
  { value: "Savar", label: "Govt College" },
];

export const skillsData = [
  { name: "Microsoft Word", type: "primary", desc: "Creating, formatting, and editing text documents" },
  { name: "Microsoft Excel", type: "primary", desc: "Data entry, formulas, sorting, filtering" },
  { name: "Microsoft Outlook", type: "primary", desc: "Emails, contacts, scheduling" },
  { name: "Communication", type: "primary", desc: "Fluent oral & written, excellent interpersonal skills" },
  { name: "IT Knowledge", type: "secondary", desc: "Sufficient technical proficiency" },
  { name: "Quick Learner", type: "secondary", desc: "Adapts well to new environments" },
  { name: "Work Ethics", type: "secondary", desc: "Strong dignity of labor" },
];

export const toolsData = [
  { name: "MS Word", icon: "📄" },
  { name: "MS Excel", icon: "📊" },
  { name: "Outlook", icon: "📧" },
  { name: "Windows", icon: "🪟" },
  { name: "Projector", icon: "📽️" },
  { name: "Creative Writing", icon: "✍️" },
];

export const educationData = [
  {
    degree: "Department of Management",
    institution: "Savar Govt. College",
    year: "2021 – Present",
    type: "Honors",
    status: "ongoing",
    details: "Developing comprehensive expertise in organizational leadership, strategic planning, and modern business operations.",
  },
  {
    degree: "Higher Secondary Certificate",
    institution: "Savar Model College",
    year: "2019 – 2020",
    type: "Business Studies",
    status: "completed",
    details: "Developed a strong foundation in core business principles, enhancing the commercial and analytical mindset required for advanced management studies.",
  },
  {
    degree: "Secondary School Certificate",
    institution: "Begun Bari High School, Dhaka",
    year: "2016 – 2018",
    type: "Science",
    status: "completed",
    details: "Established a strong foundation in science, developing the analytical and quantitative skills that complement my current management studies.",
  },
];

export const servicesData = [
  {
    title: "Senior Consultant",
    description: "Providing executive-level strategic guidance, driving complex organizational transformations, and delivering high-impact solutions for long-term growth.",
    tags: ["Strategy", "Leadership", "Advisory"],
    color: "cyan",
    gridClass: "md:col-span-2 md:row-span-2",
    iconName: "FaUserTie",
    image: "/assets/services/consultant.png",
  },
  {
    title: "Management Support",
    description: "Providing administrative and management assistance with a focus on organizational efficiency.",
    tags: ["Planning", "Coordination", "Reporting"],
    color: "cyan",
    gridClass: "md:col-span-1 md:row-span-1",
    iconName: "FaChartBar",
    image: "/assets/services/mgt.png",
  },
  {
    title: "Data Management",
    description: "Expertise in data entry, formula implementation, and spreadsheet management.",
    tags: ["Excel", "Data Entry", "Analysis"],
    color: "violet",
    gridClass: "md:col-span-1 md:row-span-1",
    iconName: "FaDatabase",
    image: "/assets/services/data.png",
  },
  {
    title: "Professional Communication",
    description: "Excellent interpersonal skills and proficiency in handling professional correspondence.",
    tags: ["Emails", "Interpersonal", "Scheduling"],
    color: "cyan",
    gridClass: "md:col-span-1 md:row-span-1",
    iconName: "FaEnvelope",
    image: "/assets/services/comm.png",
  },
  {
    title: "Content Creation",
    description: "Skilled in creative writing, report preparation, and delivering presentations.",
    tags: ["Writing", "Reports", "Presentations"],
    color: "violet",
    gridClass: "md:col-span-2 md:row-span-1",
    iconName: "FaPaintBrush",
    image: "/assets/services/content.png",
  },
];

export const hobbiesData = [
  { 
    name: "Traveling", 
    icon: "🌍", 
    desc: "Exploring new places and diverse cultures to broaden my perspective.",
    gridClass: "md:col-span-2 md:row-span-2"
  },
  { 
    name: "Reading Journals", 
    icon: "📖", 
    desc: "Staying updated with business management and leadership trends.",
    gridClass: "md:col-span-1 md:row-span-1"
  },
  { 
    name: "Social Work", 
    icon: "🤝", 
    desc: "Volunteering for community development and social causes.",
    gridClass: "md:col-span-1 md:row-span-1"
  },
  { 
    name: "Photography", 
    icon: "📸", 
    desc: "Capturing moments and perspectives through the lens.",
    gridClass: "md:col-span-2 md:row-span-1"
  },
  { 
    name: "Creative Writing", 
    icon: "✍️", 
    desc: "Documenting ideas and professional insights through articles.",
    gridClass: "md:col-span-1 md:row-span-2"
  },
  { 
    name: "Fitness", 
    icon: "🏃", 
    desc: "Maintaining a healthy lifestyle through regular exercise.",
    gridClass: "md:col-span-1 md:row-span-1"
  },
  {
    name: "Tech Exploring", 
    icon: "💻", 
    desc: "Learning about new tools and digital innovations.",
    gridClass: "md:col-span-1 md:row-span-1"
  },
  { 
    name: "Networking", 
    icon: "👥", 
    desc: "Connecting with professionals and sharing knowledge for growth.",
    gridClass: "md:col-span-3 md:row-span-1"
  },
];
